export default "__VITE_ASSET__CmwQev1A__"